<template>
  <el-dialog
      ref="dialog"
      :title="title"
      :visible.sync="isVisible"
      :show-close="isClosable"
      width="30%"
      :before-close="beforeClose"
  >
    <span v-html="content"></span>
    <span slot="footer" class="dialog-footer">
    <el-button v-if="isButtonActive('yes')" @click="start">Yes</el-button>
    <el-button v-if="isButtonActive('no')" @click="close">No</el-button>
    <el-button v-if="isButtonActive('close')" @click="close">Close</el-button>
  </span>
  </el-dialog>
</template>

<script>
const modes = {
  confirmation: {
    title: 'Confirmation',
    content: 'Do you want to perform database vacuuming?',
    buttons: ['yes', 'no'],
    isClosable: true,
  },
  vacuuming: {
    title: 'Processing...',
    content: 'Please don\'t close the page until process is finished',
    buttons: [],
    isClosable: false,
  },
  success: {
    title: 'Success',
    content: 'The database is successfully processed',
    buttons: ['close'],
    isClosable: true,
  },
  error: {
    title: 'Error',
    content: 'An error occurred during database vacuuming',
    buttons: ['close'],
    isClosable: true,
  },
};

export default {
  props: {
    url: String,
  },

  data() {
    return {
      isVisible: false,
      mode: modes.confirmation,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    title() {
      return _.get(this.mode, ['title']);
    },

    /**
     * @return {string}
     */
    content() {
      return _.get(this.mode, ['content']);
    },

    /**
     * @return {boolean}
     */
    isClosable() {
      return _.get(this.mode, ['isClosable']);
    },
  },

  methods: {
    /**
     * @param {string} name
     * @return {boolean}
     */
    isButtonActive(name) {
      return _.includes(this.mode.buttons, name);
    },

    /**
     * @return {undefined}
     */
    show() {
      this.mode = modes.confirmation;
      this.isVisible = true;
    },

    /**
     * @return {undefined}
     */
    start() {
      this.mode = modes.vacuuming;
      axios.post(this.url)
          .then(res => {
            this.mode = modes.success;
            this.$emit('vacuum');
          })
          .catch(err => {
            this.mode = modes.error;
          });
    },

    /**
     * @return {undefined}
     */
    close() {
      this.$refs.dialog.handleClose();
    },

    /**
     * @param {function} done
     */
    beforeClose(done) {
      this.mode !== modes.vacuuming && done();
    },
  },
}
</script>
